import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { ApiWaveParticipationRequirement } from "@/generated/models/ApiWaveParticipationRequirement";
export default function CreateDropContentMissingMediaWarning(t0) {
  const $ = _c(17);
  const {
    missingMedia
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      AUDIO: "Audio is required",
      VIDEO: "Video is required",
      IMAGE: "Image is required"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      AUDIO: "Please upload an audio file",
      VIDEO: "Please upload a video file",
      IMAGE: "Please upload an image file"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const TOOLTIP = t2;
  let t3;
  if ($[2] !== missingMedia[0]) {
    t3 = missingMedia[0].toLowerCase();
    $[2] = missingMedia[0];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const tooltipId = `missing-media-warning-${t3}`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#FEDF89]" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = LABELS[missingMedia[0]];
  let t6;
  if ($[5] !== t5) {
    t6 = <span className="tw-text-xs tw-text-[#FEDF89]">{t5}</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6 || $[8] !== tooltipId) {
    t7 = <div className="tw-inline-flex tw-items-center tw-gap-x-2" data-tooltip-id={tooltipId}>{t4}{t6}</div>;
    $[7] = t6;
    $[8] = tooltipId;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = TOOLTIP[missingMedia[0]];
  let t10;
  if ($[11] !== t9 || $[12] !== tooltipId) {
    t10 = <Tooltip id={tooltipId} style={t8}>{t9}</Tooltip>;
    $[11] = t9;
    $[12] = tooltipId;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7) {
    t11 = <>{t7}{t10}</>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}